import countries from 'i18n-iso-countries';
import getUnicodeFlagIcon from 'country-flag-icons/unicode';
import enLocale from 'i18n-iso-countries/langs/en.json';

// Initialize the i18n-iso-countries library with English locale
countries.registerLocale(enLocale);

// List of countries to exclude
export const excludedCountries = [
  'Afghanistan',
  'Albania',
  'Algeria',
  'Bangladesh',
  'Barbados',
  'Belarus',
  'Bhutan',
  'Bosnia and Herzegovina',
  'Botswana',
  'Burkina Faso',
  'Burundi',
  'Cambodia',
  'Cameroon',
  'Central African Republic',
  'China',
  'Cuba',
  'Democratic Republic of the Congo',
  'Ecuador',
  'Eritrea',
  'Ethiopia',
  'Gambia',
  'Gaza Strip',
  'Grenada',
  'Guinea',
  'Guinea-Bissau',
  'Haiti',
  'Iran, Islamic Republic of',
  'Iraq',
  'Jamaica',
  'Jordan',
  'Kenya',
  'Kosovo',
  'Lebanon',
  'Liberia',
  'Libya',
  'Madagascar',
  'Mali',
  'Morocco',
  'Mozambique',
  'Myanmar',
  'Nepal',
  'Nicaragua',
  'Niger',
  'Nigeria',
  'North Korea',
  'North Macedonia',
  'Pakistan',
  'Qatar',
  'Russian Federation',
  'Senegal',
  'Seychelles',
  'Slovenia',
  'Solomon Islands',
  'Somalia',
  'South Africa',
  'South Sudan',
  'Sudan',
  'Suriname',
  'Syria',
  'Tanzania',
  'Togo',
  'Tonga',
  'Trinidad And Tobago',
  'Turkey',
  'Turks and Caicos Islands',
  'Uganda',
  'Ukraine',
  'Vanuatu',
  'Venezuela (Bolivarian Republic of)',
  'Vietnam',
  'West Bank (Palestinian Territory, Occupied)',
  'Western Sahara',
  'Yemen',
  'Zimbabwe'
];

/**
 * Check if a country code is in the excluded list
 * @param code ISO Alpha-2 country code
 * @returns boolean indicating if country is excluded
 */
export const isExcludedCountry = (code: string): boolean => {
  const name = getCountryNameFromCode(code);
  return excludedCountries.some(excluded => {
    // For China we specifically want to exclude mainland China
    if (excluded === 'China' && name === 'China') return true;
    // For USA we need to match both forms
    if (excluded === 'United States' && 
        (name === 'United States' || name === 'United States of America')) return true;
    
    return name.includes(excluded);
  });
};

/**
 * Get country name from code
 * @param code ISO Alpha-2 country code
 * @returns country name
 */
export const getCountryNameFromCode = (code: string): string => {
  // Special case for Taiwan
  if (code === 'TW') {
    return 'Taiwan';
  }
  return countries.getName(code, 'en') || code;
};

/**
 * Get all country emojis except for excluded countries
 * @returns string of country flag emojis
 */
export const getAllowedCountryEmojis = (): string => {
  // Get all country codes (alpha-2)
  const countryCodes = Object.keys(countries.getAlpha2Codes());
  
  // Create a list of country emojis excluding the specified countries
  const allowedEmojis = countryCodes
    .map(code => {
      // Get the country name
      const name = countries.getName(code, 'en');
      if (!name) return null;
      
      // Check if the country is in the excluded list
      const isExcluded = isExcludedCountry(code);
      
      if (isExcluded) return null;
      
      // Get the flag emoji
      return getUnicodeFlagIcon(code);
    })
    .filter(Boolean) // Remove null entries
    .join(''); // Join all emojis into a single string
  
  return allowedEmojis;
}; 